import React from "react"

/**
 * BDSJEA-444: paginador liviano en español para tablas con `paginationServer`.
 * react-data-table-component v7.4.6 fija en inglés los aria-label de los botones
 * (First/Previous/Next/Last Page) y no permite traducirlos por opciones; se
 * entrega esta pieza por la prop `paginationComponent`. Recibe las props que la
 * tabla le pasa (rowsPerPage, rowCount, currentPage, onChangePage,
 * onChangeRowsPerPage, paginationRowsPerPageOptions, paginationComponentOptions).
 */
export const TEXTO_PRIMERA_PAGINA = "Primera página"
export const TEXTO_PAGINA_ANTERIOR = "Página anterior"
export const TEXTO_PAGINA_SIGUIENTE = "Página siguiente"
export const TEXTO_ULTIMA_PAGINA = "Última página"

const PaginacionServidor = ({
  rowsPerPage,
  rowCount,
  currentPage,
  onChangePage,
  onChangeRowsPerPage,
  paginationRowsPerPageOptions = [10, 25, 50, 100],
  paginationComponentOptions = {},
}) => {
  const { rowsPerPageText = "Filas por página", rangeSeparatorText = "de" } =
    paginationComponentOptions
  const totalPaginas = Math.max(1, Math.ceil(rowCount / rowsPerPage))
  const primera = currentPage <= 1
  const ultima = currentPage >= totalPaginas
  const desde = (currentPage - 1) * rowsPerPage + 1
  const hasta = Math.min(currentPage * rowsPerPage, rowCount)

  const boton = (etiqueta, icono, deshabilitado, onClick) => (
    <button
      type="button"
      className="btn btn-link btn-sm text-secondary px-2 py-1"
      aria-label={etiqueta}
      title={etiqueta}
      disabled={deshabilitado}
      onClick={onClick}
    >
      <i className={`mdi ${icono}`} aria-hidden="true" />
    </button>
  )

  return (
    <nav
      className="rdt_Pagination d-flex flex-wrap justify-content-end align-items-center gap-2 border-top pt-2"
      aria-label="Paginación"
    >
      <span>{rowsPerPageText}</span>
      <select
        className="form-select form-select-sm w-auto"
        aria-label={rowsPerPageText}
        value={rowsPerPage}
        onChange={e => onChangeRowsPerPage(Number(e.target.value), currentPage)}
      >
        {paginationRowsPerPageOptions.map(n => (
          <option key={n} value={n}>
            {n}
          </option>
        ))}
      </select>
      <span>{`${desde}-${hasta} ${rangeSeparatorText} ${rowCount}`}</span>
      {boton(TEXTO_PRIMERA_PAGINA, "mdi-page-first", primera, () =>
        onChangePage(1),
      )}
      {boton(TEXTO_PAGINA_ANTERIOR, "mdi-chevron-left", primera, () =>
        onChangePage(currentPage - 1),
      )}
      {boton(TEXTO_PAGINA_SIGUIENTE, "mdi-chevron-right", ultima, () =>
        onChangePage(currentPage + 1),
      )}
      {boton(TEXTO_ULTIMA_PAGINA, "mdi-page-last", ultima, () =>
        onChangePage(totalPaginas),
      )}
    </nav>
  )
}

export default PaginacionServidor
